<div class="gb-dialog-header">
  <h1 translate="RAFFLE_CONTROLS.CONFIRM.CONCLUDE_TITLE"></h1>
</div>

<div class="gb-dialog-content">
  <p [innerHTML]="'RAFFLE_CONTROLS.CONFIRM.CONCLUDE_DESC' | translate"></p>
</div>

<div class="gb-flex-button-container">
  <button mat-dialog-close mat-stroked-button translate="RAFFLE_CONTROLS.CONFIRM.OPEN_CANCEL_TEXT"></button>

  <button
    [mat-dialog-close]="false"
    mat-stroked-button
    translate="RAFFLE_CONTROLS.CONFIRM.CONCLUDE_CANCEL_TEXT"
  ></button>

  <button [mat-dialog-close]="true" mat-flat-button translate="RAFFLE_CONTROLS.CONFIRM.CONCLUDE_OK_TEXT"></button>
</div>
